import timePickerDarkRule from '../../../common/algorithms/time-picker-dark-rule';

const dark = (params) => timePickerDarkRule(params, { step: 3, darkShade: '50' });

export default dark;
